// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: false,
    jwtAuthToken: 'x-auth-token',
    apiUrl: '',
    recaptchaSiteKey: '6LfegREgAAAAAAfaCx7OktJ8fDhrMm52RH9fXcSA',
    cookieExpireTimeInDays: 14,
    inactivityTimeoutIntervalInMinutes: 60,
    authCookieDomain: 'nobli.net',
    idleDetectorDebounceTimeInMs: 500,
    idleTimeoutInMinutes: 60,
    sentryDsn: ''
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
